import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Collapse, Input, Popconfirm, Tag } from 'antd';
import RemedyEditor, { queryLanguageFor } from '../util/monaco-remedy';

const { Panel } = Collapse;

const sameConnector = (a, b) => (a || 'remedy') === (b || 'remedy');

/**
 * Editable panel for a deleteConfig entry: {form, query, description, connector?}
 */
const DeletePanel = ({ entry, allFields, index, onChange, onDelete, connectors }) => {
    const ql = queryLanguageFor(connectors, entry.connector);
    const found = allFields && allFields.find((af) => af.form === entry.form && sameConnector(af.connector, entry.connector));
    const formFields = found && found.fields;

    const genExtra = () => (
        <Popconfirm
            title={`Remove ${entry.form} from configuration?`}
            onConfirm={(e) => { e.stopPropagation(); onDelete(); }}
            onCancel={(e) => e.stopPropagation()}
        >
            <DeleteOutlined onClick={(event) => event.stopPropagation()} />
        </Popconfirm>
    );

    return (
        <Collapse defaultActiveKey={['1']} style={{marginBottom: 16}}>
            <Panel
                key={1}
                header={
                    <span>
                        {entry.form}
                        <Tag color="geekblue" style={{marginLeft: 8}}>{entry.connector || "remedy"}</Tag>
                        {entry.description && <span style={{marginLeft: 10, fontSize: 12, color: "#8c8c8c"}}>{entry.description}</span>}
                    </span>
                }
                extra={genExtra()}
            >
                <div style={{fontSize: 12, color: "#8c8c8c", marginBottom: 4}}>Description</div>
                <Input
                    value={entry.description}
                    style={{ marginBottom: 8 }}
                    onChange={(e) => onChange({ ...entry, description: e.target.value })}
                />
                <div style={{fontSize: 12, color: "#cf1322", margin: "8px 0 4px"}}>Query ({ql.name}) — all matching records will be DELETED</div>
                <RemedyEditor
                    queryLanguage={ql}
                    key={`delete-bq-editor-${index}`}
                    height={'60px'}
                    minimap={{ enabled: false }}
                    defaultValue={entry.query}
                    formFields={formFields}
                    form={entry.form}
                    onChange={(v) => onChange({ ...entry, query: v })}
                />
            </Panel>
        </Collapse>
    );
};

export default DeletePanel;
